import { clientState } from './clientState';
// These four allow-lists reflect existing Header menus, not backend authorization.
const auditedRoutes = {
  '/item': ['rcs-admin', 'rcs-store'],
  '/billing': ['rcs-admin', 'department', 'pay-cre', 'rcs-store'],
  '/jpc-user': ['rcs-admin'],
  '/indent-request': ['rcs-admin', 'department', 'dep-rep', 'pay-cre', 'rcs-store'],
};
export const canOpenRoute = pathname => {
  const roles = auditedRoutes[pathname.toLowerCase().replace(/\/+$/, '')];
  if (!roles) return true;
  try { return roles.includes(JSON.parse(clientState.getItem('user') || '{}').role?.toLowerCase()); } catch { return false; }
};
